module.exports = __webpack_public_path__ + "img/vscode-logo.9c890b01.svg";